import React from 'react';
import PropTypes from 'prop-types';
import CompanyLogoPlaceholder from '../../../assets/images/boardtrac_plus_logo.svg';
import store from '../../../stores/store';
import * as utils from '../../../helpers/utils';
import TaskStatusDropDown from './TaskStatusDropdown';
import { observer } from 'mobx-react'

const TaskCard = observer(
    class TaskCard extends React.Component {
        constructor() {
            super();

            this.state = {
                activeId:      null,
                currentStatus: null,
                hasError: false
            };
        }

//#region GET METHODS

        blockChangeStatus = (task) => {
            var isOffline = false;
            if (
                window.offlineApiExtension &&
                window.require &&
                !store.conn.isOnline
            ) {
                isOffline = true;
            }
  
            if(isOffline || (task.InstanceId.toString() + task.TaskId.toString() !== this.state.activeId)
             || (task.StatusId === 6 && task.IsAdmin !== 1)) {
                return true;
            } else {    
                // if user is GA or ASSAGNEE - enable
                if(task.IsAdmin === 1 || task.IsMyTask === 1) {
                    return false; 
                } else {    // if user is lead/chair and task privacy is lead/chair - enable
                    if(task.IsLead === 1 && task.PrivacyId === 2) {
                        return false;
                    }

                    return true;
                }               
            }  
        };

        selectGroup = () => {
            const index = store.companies.indexFromId(this.props.detail.InstanceId);
            store.groups.toggleSelected(this.props.detail.GroupId, index);
        };

        getLogo = instanceId => {
            const coIndex = store.companies.indexFromId(instanceId);
            if (typeof store.companies.logos[coIndex] !== 'undefined') {
                const logo =
                    store.companies.logos.length > 0 ? store.companies.logos[coIndex].url : '';
                return logo;
            }
            return '';
        };

//#endregion

//#region SET METHODS
        setActiveElement(id) {      
            if(id !== this.state.activeId) {
                this.setState({activeId: id})             
            }    
        }

        setCurrentStatus(status){                         
            if(this.state!== undefined && status !== this.state.currentStatus) {               
                this.setState({currentStatus: status})             
            }    
        }

        setStatusClass = (status) => {
            this.setCurrentStatus(status);
            return status.toLowerCase().replace(' ', '-');
        };

        setTaskDataRow = (instanceId, taskId, dueDate, statusId) => {
            
            let rowClasses = 'task data-row  cursor-pointer';
            
            if((instanceId.toString() + taskId.toString()) === this.state.activeId) {
                rowClasses = rowClasses + ' expand';
            }
            
            if(dueDate !== '0001-01-01T00:00:00' && statusId < 4 && utils.compareDateString(dueDate, utils.getNowInUtc())) {
                rowClasses = rowClasses + ' overdue';
            } 

            return rowClasses;
        };

//#endregion

        

//#region ON ACTION METHODS

        onCardClick = (task) => {
            this.setActiveElement(task.InstanceId.toString() + task.TaskId.toString());
            store.tasks.markTaskAsViewed(task.InstanceId, task.GroupId, task.TaskId)
            this.forceUpdate();
        };

        onCloseClick = () => {                                 
            this.setActiveElement("0");              
        };

        onChangeStatus = async (instanceId, groupId, taskId, statusId) => { 
                await this.props.onChangeStatus(instanceId, groupId, taskId, statusId);
        };

//#endregion

//#region FORMAT METHODS

        formatDate = (dateString) => {
            if (dateString !== '0001-01-01T00:00:00') {
                 var fullDateFormated =  utils.getFormattedDateFromString(dateString);
                 return fullDateFormated.substring(0, fullDateFormated.indexOf('-')-1);
            }

            return null;
        };

        formatTime = (dateString) => {
            if (dateString !== '0001-01-01T00:00:00') {
                 var fullDateFormated =  utils.getFormattedDateFromString(dateString);
                 return fullDateFormated.substring(fullDateFormated.indexOf('-')+2);
            }

            return null;
        };

//#endregion

//#region RENDER METHODS

        render() {

            const task = this.props.detail;
            const logo = this.getLogo(task.TaskId);
            const group = store.groups.getGroup(this.props.instanceId, this.props.detail.GroupId);
            var groupName = '';
            
            if (group !== null && group !== undefined) {
                groupName = group.GroupName
            }

            return (
                <div className={this.setTaskDataRow(task.InstanceId, task.TaskId, task.DueDateTime, task.StatusId)} onClick={this.onCardClick.bind(this, task)}>
                    <div className="field-grp">
                        <div className={task.IsNew ? 'unviewed-task' : ''}>{task.Title}
                        <button type="button" className="btn btn-secondary ml-auto" style={{visibility: (task.InstanceId.toString() + task.TaskId.toString() !== this.state.activeId ? 'hidden' : '')}} onClick={this.onCloseClick.bind(this)}><i className="fa fa-times-thin fa-lg"></i></button>
                        </div>
                        <div>{task.Description}
                        </div>
                    </div>
                    <div className="field-grp">                       
                        <div>{task.CategoryName}</div>
                        <div>{this.formatDate(task.DueDateTime)}                
                            <small className="text-muted d-flex">{this.formatTime(task.DueDateTime)}</small>
                        </div>
                        <div>{task.AssigneeName}</div>
                        {this.blockChangeStatus(task) ?
                        <div>
                            <TaskStatusDropDown
                            task = {task}
                            key={task.InstanceId + task.TaskId}                          
                            status = {task.Status}
                            onChangeStatus = {this.onChangeStatus}
                            setStatusClass = {this.setStatusClass}
                            isStatic = {true}
                            />
                            <small className="text-muted d-flex">{task.Privacy}</small>
                        </div> :
                        <div className="overflow-visible">                       
                        <TaskStatusDropDown
                            task = {task}
                            key={task.InstanceId + task.TaskId}                          
                            status = {task.Status}
                            onChangeStatus = {this.onChangeStatus}
                            setStatusClass = {this.setStatusClass}
                            isStatic = {false}
                            />
                        <small className="text-muted d-flex">{task.Privacy}</small>
                    </div>}
                    </div>
                    <div className="field-grp field-grp-hr">                       
                        <div className="small text-muted d-flex align-items-center cursor-pointer">
                           <img
                                className="my-auto mx-auto img-fluid"
                                src={logo ? logo : CompanyLogoPlaceholder}
                                alt="company logo"
                               style={{ height: 18 }}
                             />
                        </div>
                        <div
                            className="small text-muted d-flex align-items-center cursor-pointer"
                                onClick={() => this.selectGroup()}>{groupName}
                        </div> 
                    </div>
                </div>
            );
        }

//#endregion
    }
)

TaskCard.propTypes = {
    detail:         PropTypes.object.isRequired,
    instanceId:     PropTypes.number.isRequired,
    onChangeStatus: PropTypes.func.isRequired
};

export default TaskCard;


// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Task/TaskCard.js